module.exports = __webpack_public_path__ + "static/media/booking.9a9024e4.svg";